<template>
    <div class="loading-filters">
        <div class="heading"></div>
        <div class="med"></div>

        <div class="space"></div>

        <div class="heading"></div>
        <div class="med"></div>

        <div class="space"></div>

        <div class="heading"></div>
        <div class="long"></div>
        <div class="med"></div>
        <div class="short"></div>
        <div class="long"></div>

        <div class="space"></div>

        <div class="heading"></div>
        <div class="med"></div>
        <div class="short"></div>
        <div class="long"></div>
        <div class="full"></div>
        <div class="long"></div>
    </div>
</template>

<script>
export default {
    name: 'LoadingSearchFilters'
}
</script>